export default "__VITE_ASSET__B8mBy1TJ__"